import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreditNotesPayableForm.FieldSection', {
    contactFieldTitle: 'Supplier',
    contactFieldPlaceholder: 'Choose supplier',
    dateFieldTitle: 'Date',
    dateFieldPlaceholder: 'Enter date',
    referenceFieldTitle: 'Reference',
    referenceFieldPlaceholder: 'Enter reference',
    addContactButton: '+ New Contact',
    multipleSuppliersWarning: 'Multiple suppliers detected. Check suggested suppliers.',
});
